<template>
  <div class="PlatformDetail">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <van-nav-bar
          :title="$t('center.platformInfo')"     
        >
        </van-nav-bar>
             <!-- left-arrow      @click-left="$router.push('/PlatformInfo')" -->
      </div>
    </div>

    <div class="platWrap bodybox ninew">
      <div class="text-center">
        <img
          class="platPhoto"
          :src="image"
        />
      </div>
      <div class="text-center sixTop fs-20">{{name}}</div>

      <!-- <div class="bg_white twentyTop">
        <div class="ninew linkwrap flexlr">
          <div>平台链接</div>
          <div>{{link}}</div>
        </div>
        <div class="ninew flexlr">
          <div>平台二维码</div>
          <div>
            <img
              class="linkPhoto"
              :src="qrcode"
            />
          </div>
        </div>
      </div> -->

      <!-- 三宫格 -->
      <div class="twentyTop">
        <van-grid :column-num="3" gutter="10" clickable style="padding-left:0">
          <van-grid-item
            v-for="(shop, index) in shopList"
            :key="index"
            @click="goShop(shop.link)"
            :style="(index + 1) % 3 == 0 ? 'padding-right:0;' : ''"
          >
            <div class="shopBj">
              <van-image
                v-if="shop.image"
                class="shopIcon"
                round
                width="80"
                height="80"
                :src="shop.image"
              />
              <van-image
                v-else
                class="shopIcon"
                round
                width="80"
                height="80"
                src="./static/img/boss_shop_s.png"
              />
            </div>
            <div class="shopname1">
              <p class="shopname">{{ shop.name }}</p>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shopList: [],
      image:"",
      qrcode:"",
      link:"",
      name:"",
    };
  },
  mounted() {
    this.getPlatform();
  },
  methods: {
    getPlatform() {
      this.$axios({
        method: "get",
        // headers: {
        //   Authorization: "Bearer " + sessionStorage.token,
        // },
        url: this.$build + "/api/platform/" + this.$route.query.id + "/detail",
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.shopList = res.data.associations;
            this.image = res.data.data.image.path;
            this.qrcode = res.data.data.qrcode.path;
            this.link=res.data.data.link
            this.name=res.data.data.name;
            // this.platformInfo.name=res.data.data.image.id;
            // this.platformInfo.name=res.data.data.qrcode.id;
            // this.platformInfo.link=res.data.data.link;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message"),
          });
        });
    },
    goShop(link) {
      if (link) {
        window.open(link);
      }
    },
  },
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
  margin-top: 15px;
}
.PlatformDetail {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}
.platWrap {
  padding-top: 20px;
}
.text-center{
  text-align: center;
}
.platPhoto {
  width: 108px;
  height: 108px;
}
.linkwrap {
  padding: 15px 0;
}
.linkPhoto {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}
.shopname1 {
  height: 36px;
  align-items: center;
  display: inline-flex;
}
.shopBj {
  width: 100%;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
.shopIcon {
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/Platform/PlatformDetail.vue